import React from 'react';

import {
  Section, Container, ContactSection,
} from 'components';
import { histories, contests, news, companyProfiles } from './data';
import {
  SectionTitle, Title, Content, Wrapper, Divider,
  ProfileWrapper, ProfileImage, NewsItem,
} from './style';

const Company: React.FC = _ => {
  const sortRecent = (data: Array<any>) => {
    const sortedData = data.sort((d1, d2) => {
      const d1Date: any = new Date(d1.date);
      const d2Date: any = new Date(d2.date);

      return d2Date - d1Date;
    });
    return sortedData;
  }

  const clickNews = (url: string) => {
    window.open(url, "_blank")
  }

  return (
    <div>
      <Section minHeight={250}>
        <SectionTitle>10fingers</SectionTitle>
        <p>로컬 광고의 새로운 가능성을 열어가는 사람들</p>
      </Section>

      <Container>
        <Wrapper>
          <div>
            <Title>주요 연혁</Title>
            <div>
              {
                sortRecent(histories).map((item, idx) => {
                  return (
                    <Content key={idx}>
                      - {item.date} {item.content}
                    </Content>
                  );
                })
              }
            </div>
          </div>

          <Divider />

          <div>
            <Title>수상 이력</Title>
            <div>
              {
                sortRecent(contests).map((item, idx) => {
                  return (
                    <Content key={idx}>
                      - {item.date} {item.content}
                    </Content>
                  );
                })
              }
            </div>
          </div>

          <Divider />

          <div>

          </div>

          <ProfileWrapper>
            {
              companyProfiles.map((item, idx) => {
                return (
                  <ProfileImage
                    key={idx}
                    src={item.imgUrl}
                    alt="회사 이미지"
                  />
                )
              })
            }
          </ProfileWrapper>

          <Divider />

          {
            sortRecent(news).map((item, idx) => {
              return (
                <NewsItem key={idx} onClick={() => clickNews(item.url)}>
                  <h3>{item.title}</h3>
                  <p>{item.content}</p>
                  <div>
                    <img src={item.img} alt={item.press} />
                    <p>{item.date}</p>
                  </div>
                </NewsItem>
              );
            })
          }
        </Wrapper>
      </Container>

      <ContactSection />
    </div>
  );
};

export default Company;
